import {Formik, FormikProps, useFormikContext} from "formik";
import React, {Fragment, useContext, useEffect, useState} from "react";
import {UserProfileFormValues} from "../../../app/models/user-profile";
import {useHistory, useParams} from "react-router-dom";
import PersonalInformation from "./agent-form-personal-info-section";
import Settings from "./agent-form-settings";
import {Store} from "../../../app/stores/store-root";
import {observer} from "mobx-react-lite";
import {schema} from "./agent-form-validation";
import {
    EuiBreadcrumbs,
    EuiButton,
    EuiForm,
    EuiLoadingContent,
    EuiPageContent,
    EuiPageContentHeader, EuiPageContentHeaderSection,
    EuiSpacer, EuiText
} from "@elastic/eui";
import * as _ from 'lodash';
import AgentErrorModal from "./modal-agent-error";

const AgentForm = () => {
    const store = useContext(Store);
    var initialFromsValue = new UserProfileFormValues();
    initialFromsValue.Id = store.generateRandom().toString();
    const history = useHistory();
    const [profile, setProfile] = useState(initialFromsValue);
    const {loadLookups} = store.Lookups;
    const {loadExchanges} = store.Exchanges;
    const {loadAgent, saveUserProfile, createUserProfile} = store.Agents;
    const [error, setError] = useState(undefined);
    const [isEdit, setIsEdit] = useState(false);
    const [currencyCode, setCurrencyCode] = useState('');
    const [currencySymbol, setCurrencySymbol] = useState('')
    const [submitting, setSubmitting] = useState(false);
    const [loading, setLoading] = useState(false);
    const {id} = useParams();
    const formik = useFormikContext();
    const onCountryChange = (id: string) => {
        const item = store.Lookups.countryRegistry.find((item) => item.key === id);
        console.log('Found Currency ', item)
        if (item) {
            setCurrencyCode(item.currencyCode);
            setCurrencySymbol(item.currencySymbol);
        }
    }
    const onSubmit = (values: UserProfileFormValues) => {
        values.ReportsTo = store.Users.Sub;
        if (isEdit) {
            setSubmitting(true);
            console.log("Editing ", values);
            saveUserProfile(values).then(()=>{
                history.push('/agents')
            }).catch((error)=>{
                console.log(JSON.stringify(error));
                store.Modal.closeModal();
                store.Modal.openModal(<AgentErrorModal error={JSON.stringify(error)}/>)
            }).finally(()=> {
                setSubmitting(false);

            });
        } else {
            console.log("New ", values);
            console.log(values.Country);
            values.UserName = values.CountryCode.toUpperCase() + "-" + store.generateRandom();
            console.log(values);
            setSubmitting(true);
            createUserProfile(values).then(()=>{
                history.push('/agents')
            }).catch((error)=>{
                console.log(error.response.data);
                store.Modal.closeModal();
                store.Modal.openModal(<AgentErrorModal error={error.response.data.error}/>)
            }).finally(()=> {
                setSubmitting(false);

            });
        }
    };

    useEffect(() => {
        const loadLookup = async () => await loadLookups();
        const loadExchange = async () => await loadExchanges();
        const loadData = async (id: string) => {
            const result = await loadAgent(id);
            console.log("Agent Object ", result);
            return result;
        };
        if (id) setIsEdit(true);

        loadLookup().catch((e) => {
            console.log("agent-Form.tsx : problems loading lookup :  ", error);
            setError(e);
        });

        setLoading(true);
        loadExchange().then((_) => {
            if (isEdit)
                loadData(id)
                    .then((agent) => {
                        console.log(agent);
                        setProfile(new UserProfileFormValues(agent));
                    })
                    .catch((e) => {
                        console.log("agent-Form.tsx : problems loading Agent :  ", error);
                        setError(e);
                    }).finally(() => {
                    setLoading(false)
                });
        }).finally(() => setLoading(false));
    }, [error, id, isEdit, loadAgent, loadExchanges, loadLookups]);

    const editModeBreadcrumbs = [
        {
            text: 'Remittance App',
            href: '#',
            onClick: (e: any) => {
                e.preventDefault();
            },
            'data-test-subj': 'breadcrumbsAnimals',
        },
        {
            text: 'Agents & User Profiles',
            href: '#',
            onClick: (e: any) => {
                e.preventDefault();
            },
        },
        {
            text: `${id}`,
        },

        {
            text: 'Edit',
        },
    ];
    const breadcrumbs = [
        {
            text: 'Remittance App',
            href: '#',
            onClick: (e: any) => {
                e.preventDefault();
            },
            'data-test-subj': 'breadcrumbsAnimals',
        },
        {
            text: 'Agents & User Profiles',
            href: '#',
            onClick: (e: any) => {
                e.preventDefault();
            },
        },

        {
            text: 'Create',
        },
    ];

    return (
        <div>
            {loading ? <EuiLoadingContent lines={10}/> :
                (<Formik
                    onSubmit={(values: UserProfileFormValues) => {
                        onSubmit(values);
                    }}
                    validationSchema={schema}
                    initialValues={profile}
                    enableReinitialize={true}
                >
                    {(formik: FormikProps<UserProfileFormValues>) => (
                        <Fragment>
                            <EuiPageContent>
                                <EuiBreadcrumbs
                                    breadcrumbs={(isEdit)?editModeBreadcrumbs:breadcrumbs}
                                    truncate={false}
                                    aria-label="An example of EuiBreadcrumbs"
                                />
                                <EuiSpacer size="xs"/>
                                <EuiPageContentHeader>
                                    <EuiPageContentHeaderSection>
                                        <EuiText>
                                            <h1>{(isEdit)?`User Profile (${id})`:`New User Profile`}</h1>
                                            <p>
                                            if you are <span className="text-purple-600 ...">business admin</span> you can create , <b >receiving admins</b>, <b>sending agents</b>. If you are <span
                                                className="text-purple-600 ...">receiving admin</span> you can create <b>receiving supervisors</b> and <b>cashiers</b>
                                            </p>
                                        </EuiText>
                                    </EuiPageContentHeaderSection>
                                    <EuiPageContentHeaderSection>
                                        <EuiButton  fill>New User Profile</EuiButton>
                                    </EuiPageContentHeaderSection>
                                </EuiPageContentHeader>

                            </EuiPageContent>
                            <EuiSpacer/>
                            <EuiForm isInvalid={!formik.isValid && formik.submitCount>0} error={_.values(formik.errors)}>
                                <form onSubmit={formik.handleSubmit}>
                                    <div>
                                        <PersonalInformation onCountryChange={onCountryChange} submitting={submitting}/>
                                        <Settings currencyCode={currencyCode} currencySymbol={currencySymbol}
                                                  submitting={submitting} showReceivingAgentRoles={store.Users.isReceiveAgent}/>
                                    </div>
                                    <div className={'flex justify-end mt-8 space-x-4'}>
                                        <EuiButton isLoading={submitting} type='submit'>
                                            Save User Profile
                                        </EuiButton>

                                        <EuiButton isLoading={submitting} type={"button"} onClick={() => {
                                            history.push('/agents');
                                        }}>
                                            Cancel </EuiButton>
                                    </div>
                                </form>
                            </EuiForm>
                        </Fragment>

                    )}
                </Formik>)}
        </div>
    );
};

export default observer(AgentForm);
